/* global gtag */

export default function installGoogleAnalytics(callback) {
  const DEFAULT_ACCOUNT = 'G-NZKLZ1NZZN';
  let account = DEFAULT_ACCOUNT;

  const head = document.getElementsByTagName('head')[0];
  let ga4 = document.createElement('script');
  ga4.src = 'https://www.googletagmanager.com/gtag/js?id=' + account;

  ga4.onload = function() {
    document.body.appendChild(ga4);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
    gtag('js', new Date());
    gtag('config', account);
    callback();
  };

  head.insertBefore(ga4, head.children[1]);
}
